const RIGHT_PANEL_WIDTH_CSS_VARIABLE = '--right-sidebar-width';

export const syncRightPanelWidthToCSS = (width: number) => {
  if (typeof document !== 'undefined') {
    document.documentElement.style.setProperty(RIGHT_PANEL_WIDTH_CSS_VARIABLE, `${width}px`);
  }
};
